/* Package imports */
import { useSelector, useDispatch } from "react-redux";
/* Component imports */
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
/* Utility imports */
/* Style imports */
import appStyles from "../App.module.css";
import { useNavigate } from "react-router-dom";
import { authActions } from "../store/auth/auth";
import { globalFeedbackActions } from "../store/globalFeedback/globalFeedback";

const FeedbackModal = (props) => {
//   const { t } = useTranslation();
  const navigate = useNavigate();
  const globalFeedback = useSelector((state) => {
    return state.globalFeedback;
  });
  const dispatch = useDispatch();
  const handleClose = () => {
    if (globalFeedback?.onClose === "unauthorized") {
      dispatch(authActions.logout());
      navigate("/account/login", { replace: true }); // Redirect to login page
    }
    dispatch(globalFeedbackActions.hideFeedback());
    // Close the modal
  };
  return (
    <Modal
      show={globalFeedback.show}
      onHide={handleClose}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {globalFeedback.type === "error" ? (
            <span className={appStyles.dangerText}>
              {"Something went wrong."}
            </span>
          ) : (
            <span className={appStyles.successText}>{"Success."}</span>
          )}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>{globalFeedback.message || "Your request was successfully processed."}</div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleClose}
          variant={globalFeedback.type === "error" ? "light" : "success"}
        >
          {"Close"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default FeedbackModal;